import { registerEvents } from "./skyward.ui.events";
import { JQueryInput } from "./types";
import { Key, IconType } from "./types/skyward/svg";

const events =
{
    forceReload
};

registerEvents("svg", events);

const skyward = window.skyward;

const svgNS = "http://www.w3.org/2000/svg";
const xlinkNS = "http://www.w3.org/1999/xlink";

function createSvg(key: Key)
{
    //Necessary because jQuery doesn't play nicely with SVGs
    //       var svg = document.createElementNS(svgNS, "svg");
    //       var use = document.createElementNS(svgNS, "use");
    // Cross-origin <use> tags are completely forbidden - CSP and CORS don't apply, they're just blocked.
    // For iframes without sandbox=allow-same-origin, iframeListener.js will download the spritesheet and add it to the document.
    const svg = document.createElementNS(svgNS, "svg");
    const use = document.createElementNS(svgNS, "use");

    if (window.parent === window)
    {
        use.setAttributeNS(xlinkNS, "href", `${skyward.global.virtualDir}skysys/svg/spritesheet?v=2#svg-${key}`);
    }
    else
    {
        use.setAttributeNS(xlinkNS, "href", `#svg-${key}`);
    }
    svg.appendChild(use);
    return $(svg);
}

export function getSvg(key: Key, type?: IconType, fillColor?: string)
{
    const svg = createSvg(key);
    svg.addClass(key.replaceAt(0, key[0].toLowerCase())).addClass("svg");

    if (type)
    {
        svg.addClass("svg" + type.replaceAt(0, type[0].toUpperCase()));
    }

    if (fillColor)
    {
        svg.css('fill', fillColor);
    }

    return svg;
}

export function swapSvg(elementToReplace: JQueryInput | JQuery<SVGElement>, newSvgName: Key, newSvgType?: IconType)
{
    const svg = getSvg(newSvgName, newSvgType);
    $(elementToReplace as any).replaceWith(svg);
    return svg;
}

function forceReload(this: JQuery<HTMLElement>)
{
    const use = this[0].querySelector("use")!;
    use.setAttributeNS(xlinkNS, "href", use.getAttributeNS(xlinkNS, "href")!);
}
